import { useTheme, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { getRemediationIconTextAndColor } from '../../utils/palette.utils';

function NRRemediationStatusButton({ status, handleOnClick, isInteractive = true, small = false, styleAdaptative = false }) {
  const theme = useTheme();
  let [Icon, text, color, altColor] = getRemediationIconTextAndColor(status, theme);

  return (
    <Button
      onClick={() => handleOnClick(status)}
      sx={{
        color: altColor || color,
        backgroundColor: alpha(color, 0.15),
        height: small ? theme.spacing(3) : theme.spacing(3.5),
        pointerEvents: isInteractive ? 'auto' : 'none',
        '&:hover': {
          backgroundColor: alpha(color, theme.palette.action.hoverOpacity)
        }
      }}
    >
      <Box
        sx={{
          width: isInteractive || styleAdaptative ? 'auto' : theme.spacing(15),
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Icon
          sx={{
            pr: theme.spacing(0.5),
            width: '16px',
            height: '16px',
            color
          }}
        />
        <Typography
          sx={{
            fontSize: theme.spacing(1.5),
            fontWeight: theme.typography.fontWeightBold,
            lineHeight: theme.spacing(1.75)
          }}
        >
          {text}
        </Typography>
      </Box>
    </Button>
  );
}

export default NRRemediationStatusButton;
